const Reminder1Notification = `Ei! Não esqueceu da gente, né? 🤭

_*{{CONTACT.NAME}}*_ espero que esteja tudo bem por aí!

Lembra da pesquisa sobre bem-estar pós-parto da UNIFESP?

Precisamos de você de novo! Dá uma passadinha aqui: {{LINK.FORMS}}

Bora lá responder umas perguntinhas rápidas e compartilhar sua experiência conosco até _{{CALENDAR.END_AT}}_. 🙏

Sua opinião é super importante para o projeto PEARLS!

Até mais,

_*{{USER.NAME}}*_ e _*Equipe Projeto PEARLS Brazil*_ _UNIFESP_`;

export { Reminder1Notification };
